export type ApiHeaderContext = {
  endpoint?: string;
  accessToken: string | null;
  appVersion: string;
  clientUuid: string;
};

export const prepareApiHeaders = (
  headers: Headers,
  context: ApiHeaderContext
) => {
  headers.set('X-App-Version', context.appVersion);
  headers.set('X-Client-UUID', context.clientUuid);

  if (context.accessToken) {
    headers.set('Authorization', `Bearer ${context.accessToken}`);
  }

  return headers;
};
